import { API_ENDPOINT } from 'env'

export const getCreditos = async ({ ano }) => {
  const storageData = localStorage.getItem('state')
  const parsed = JSON.parse(storageData)

  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${parsed.auth.token}`
    },
  }

  const res = await fetch(`${API_ENDPOINT}/creditos?ano=${ano}`, options)

  if (!res.ok) throw new Error('Erro to fetch de data')

  const data = await res.json()
  return data
}

export const cadastrarCreditos = async ({ projetoId, unidadeId, credito }) => {
  const storageData = localStorage.getItem('state')
  const parsed = JSON.parse(storageData)

  const options = {
    method: 'post',
    body: JSON.stringify({ projetoId, unidadeId, credito }),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${parsed.auth.token}`
    },
  }
  const res = await fetch(`${API_ENDPOINT}/creditos`, options)

  if (!res.ok) {
    const error = await res.json()
    throw new Error(error.message)
  }

  return res.json()

}